import { memo, type ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Col, Divider, Flex, Space, Typography } from 'antd';

import { getSignUpViaEmailPath } from '@/shared/constants/router';

import cls from './sign-up-content.module.css';

interface SignUpContentProps {
    agreementLinksSlot: ReactNode;
    googleSignUpButtonSlot: ReactNode;
}

export const SignUpContent = memo((props: SignUpContentProps) => {
    const { agreementLinksSlot, googleSignUpButtonSlot } = props;

    const { t } = useTranslation('auth');

    const navigate = useNavigate();

    const goToSignUpVieEmail = useCallback(() => {
        navigate(getSignUpViaEmailPath());
    }, [navigate]);

    return (
        <Col className={cls.root}>
            <Space
                className="full-width"
                direction="vertical"
                size={24}
            >
                <Col>
                    <Button
                        block
                        onClick={goToSignUpVieEmail}
                        type="primary"
                    >
                        {t('signUpContentButton')}
                    </Button>
                    <Divider plain>{t('signUpContentDivider')}</Divider>
                    {googleSignUpButtonSlot}
                </Col>
                <Flex
                    align="center"
                    className={cls.textContainer}
                    justify="center"
                    vertical
                >
                    <Typography.Text>
                        {t('signUpContentAgreement')}
                    </Typography.Text>
                    {agreementLinksSlot}
                </Flex>
            </Space>
        </Col>
    );
});

SignUpContent.displayName = 'SignUpCard';
